import Reveal from "./Reveal";
import SectionHeading from "./SectionHeading";
import ArtFrame from "./ArtFrame";

const Upcoming = ({ books }) => {
  const upcoming = books.filter((b) => b.status === "coming_soon");

  return (
    <section id="upcoming" data-testid="upcoming-section" className="relative z-10 px-6 py-28 md:px-16 lg:px-24 lg:py-40">
      <SectionHeading
        title="UPCOMING BOOKS"
        eyebrow="Stories currently being written among the stars."
      />
      <div className="grid grid-cols-2 gap-5 md:grid-cols-3 md:gap-8 xl:grid-cols-5">
        {upcoming.map((book, i) => (
          <Reveal key={book.id} delay={0.08 * i}>
            <div data-testid={`upcoming-card-${book.id}`} className="group">
              <ArtFrame
                image={book.image}
                hue={book.hue}
                label={book.part}
                veil
                className="border border-white/10 shadow-[0_20px_60px_rgba(0,0,0,0.7)]"
              />
              <div className="mt-5">
                <span className="font-mono text-[10px] tracking-[0.4em] text-[#D4AF37]">{book.part}</span>
                <h3 className="mt-2 text-sm tracking-wider text-[#F5F5FA]">{book.title}</h3>
                <p className="mt-2 text-xs font-light leading-relaxed text-[#A0A0B0]">{book.description}</p>
                <p className="mt-3 font-tech text-[8px] uppercase text-[#8B0000]">Status — Coming soon</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Upcoming;
